import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class ValidationMessage extends Vue {
    @Prop() prop: any;

    @Prop() path: string;

    @Prop() errorsKey: string;

    public get errors() {

        var source = this.prop;
        if (this.path) {
            var segments = this.path.split(".");
            for (let i = 0; i < segments.length; i++) {
                if (!source) {
                    break;
                }
                source = source[segments[i]];
            }
        }

        if (this.errorsKey && source) {
            source = source[this.errorsKey];
        }

        if (!source) {
            return [];
        }

        return source.errors;
    }


}


// WEBPACK FOOTER //
// ./www/js/Components/ValidationMessage/ValidationMessage.ts